var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bars"},_vm._l((_vm.navs),function(nav){return _c('router-link',{key:nav.path,staticClass:"tab-item",attrs:{"to":nav.path}},[_c('img',{attrs:{"src":nav.icon}}),_c('span',{staticClass:"_name"},[_vm._v(_vm._s(nav.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }